(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-packages.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-packages.js');

'use strict';

const StartPackages = () => {
  const handleClick = (rows, price) => {
    svs.components.analytics.trackEvent({
      category: 'lotto_startPage',
      action: 'CTA_predefined',
      opt_label: "".concat(rows, "rader"),
      opt_value: price
    }, () => {
      svs.utils.url.navigate("lotto/fardiga-spel/".concat(price));
    });
  };
  const packages = svs.numbergames.rules.getRules(svs.numbergames.productMapping.CONSTANTS.LOTTO).PACKAGES;
  return React.createElement("div", {
    className: "start-packages"
  }, React.createElement("div", {
    className: "packages-body"
  }, React.createElement("h2", {
    className: "packages-header js-packages-header"
  }, "Vill du spela f\xE4rdiga spel?"), React.createElement("div", {
    className: "package-wrapper js-packages-wrapper"
  }, Object.entries(packages).map(_ref => {
    let [price, details] = _ref;
    return React.createElement("div", {
      className: "package",
      key: price,
      onClick: () => handleClick(details.rows, Number(price))
    }, React.createElement("div", {
      className: "package-rows"
    }, "".concat(details.rows, " rader")), React.createElement("div", {
      className: "package-price"
    }, "".concat(price, " kr")));
  }))));
};
setGlobal('svs.lotto.react.components', {
  StartPackages
});

 })(window);